var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontpageStep2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.607,
    height: 130.025,
    viewBox: "0 0 144.607 130.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-727 -1010.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-25 456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(834.656 554.423)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 30.976,
    cy: 30.976,
    rx: 30.976,
    ry: 30.976,
    transform: "translate(0 31.145)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(19.603 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M268.384,791.706a6.51,6.51,0,0,0,3.11,2.64,5.605,5.605,0,0,0-3.607-6.688A6.51,6.51,0,0,0,268.384,791.706Z",
    transform: "translate(-256.053 -722.679)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M240.3,819.539a6.51,6.51,0,0,1,2.49,3.23,5.605,5.605,0,0,1-6.511-3.917A6.51,6.51,0,0,1,240.3,819.539Z",
    transform: "translate(-227.289 -751.119)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M303.98,520.72c2.817-7.409,3.224-17,2.633-27.488q-.013-.248-.028-.5-.133-2.269-.324-4.588h6.149q-.125,2.408-.178,4.77c0,.1,0,.208-.007.31-.2,10.082.706,19.449,3.647,27.494Z",
    transform: "translate(-289.148 -448.992)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M172.152,61.354c-.214,12.379-9.284,16.546-20.38,16.354q-.387-.007-.769-.02-.771-.027-1.526-.084c-10-.753-17.706-5.432-17.507-16.944.206-11.914,19.623-25.5,21.038-26.584C153.01,34.075,172.366,48.975,172.152,61.354Z",
    transform: "translate(-131.966 -34.075)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M303.851,78l-.143-1.5-.7-3.271-1.55-7.209,6.871-12.569-6.845,10.975.074-4.567,4.736-9.094-4.716,7.885.134-8.216,5.07-7.24-5.049,5.948.083-15v-.064l0,.065-.5,19.023-5.135-7.857,5.073,9.469-.48,9.176-.015-.243-5.943-8.3,5.925,9.165-.06,1.147-.011.018.005.094-1.521,7.4-.943,4.588q.016.25.028.5c.865.019,5.045-.012,5.611-.006Z",
    transform: "translate(-280.768 -34.075)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(789.303 561.437)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48-2",
    "data-name": "Ellipse 48",
    cx: 30.976,
    cy: 30.976,
    rx: 30.976,
    ry: 30.976,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(17.725 0.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M49.04,443.607c.234,12.649-7.2,17.2-16.48,17.376q-.323.006-.643,0-.645,0-1.277-.035c-8.382-.438-14.973-4.961-15.19-16.725-.225-12.174,15.051-27.825,16.2-28.983h0l.066-.066S48.806,430.958,49.04,443.607Z",
    transform: "translate(-15.396 -415.177)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M106.562,459.068l5.984-8.7-5.982,9.639,0,.986q-.645,0-1.277-.035l.428-12.667-.007-.1.011-.019.041-1.2-6.35-9.435,6.352,8.539.02.253.323-9.57L100.639,427l5.5,8.088.155-19.833v0l.2,15.634,5.146-6.295-5.144,7.641.019,8.564,4.762-8.307-4.759,9.566.011,4.762,6.92-11.568-6.917,13.229Z",
    transform: "translate(-90.045 -415.186)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M78.166,593.041q-2.7-.526-5.193-.9l.657-1.465c-.222-.089-1.195.751-1.195.751l.862-4.253c-1.114.155-1.681,4.5-1.681,4.5L70.373,590.2l.6,1.651A100.144,100.144,0,0,0,57.8,590.9l.562-1.254c-.222-.089-1.195.751-1.195.751l.862-4.253c-1.114.155-1.681,4.5-1.681,4.5L55.1,589.167l.638,1.748a64.513,64.513,0,0,0-7.573.592,10.568,10.568,0,0,1,2.5-3.812,4.421,4.421,0,0,0-2.654,2.139A38.943,38.943,0,0,1,49.738,578s-3.05,7.635-2.661,12.759l.047.91a26.969,26.969,0,0,0-3.886.869Z",
    transform: "translate(-43.238 -546.42)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 28.567,
    cy: 28.567,
    rx: 28.567,
    ry: 28.567,
    transform: "translate(754.084 596.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M383.3,387.609c-.33,0-.664-.005-.991-.015l.007-.238c.47.015.95.019,1.422.012l0,.238Q383.518,387.609,383.3,387.609Zm1.874-.055-.014-.238c.471-.028.948-.067,1.418-.116l.025.237C386.126,387.486,385.646,387.526,385.171,387.554Zm-4.3-.037c-.475-.036-.955-.084-1.426-.142l.029-.236c.468.057.944.1,1.415.141Zm7.146-.262-.036-.235c.468-.071.939-.153,1.4-.245l.046.233c-.465.092-.94.176-1.412.247Zm-9.991-.087c-.469-.079-.943-.171-1.407-.272l.05-.233c.461.1.931.191,1.4.27Zm12.8-.472-.057-.231c.459-.114.921-.239,1.373-.373l.068.228C391.76,386.455,391.294,386.582,390.832,386.7Zm-15.6-.136c-.46-.122-.923-.257-1.376-.4l.072-.227c.45.142.909.276,1.366.4Zm18.349-.679-.078-.225c.446-.155.894-.322,1.332-.5l.088.221c-.442.177-.894.346-1.343.5Zm-21.085-.186c-.447-.164-.9-.342-1.336-.527l.092-.219c.436.184.883.36,1.326.523Zm23.743-.877-.1-.217c.428-.194.858-.4,1.279-.617l.108.212c-.424.216-.857.426-1.288.622Zm-26.39-.237c-.43-.2-.861-.422-1.281-.647l.112-.21c.418.223.845.439,1.272.642Zm28.937-1.065-.118-.207c.41-.234.82-.48,1.218-.732l.127.2c-.4.253-.813.5-1.227.737Zm-31.468-.288c-.409-.243-.818-.5-1.216-.762l.131-.2c.4.26.8.515,1.207.756Zm33.887-1.243-.136-.2c.387-.27.772-.553,1.146-.84l.145.189C401.981,381.428,401.592,381.713,401.2,381.985Zm-36.283-.335c-.384-.279-.768-.571-1.141-.869l.149-.186c.37.3.751.586,1.132.862Zm38.554-1.41-.153-.182c.36-.3.719-.621,1.066-.942l.162.175c-.35.323-.711.642-1.074.949Zm-40.794-.379c-.358-.313-.713-.639-1.057-.969l.165-.172c.341.327.693.651,1.049.962Zm42.9-1.567-.169-.167c.332-.337.661-.685.976-1.035l.177.159c-.318.353-.649.7-.984,1.043Zm-44.966-.418c-.328-.345-.653-.7-.964-1.061l.18-.156c.309.356.631.71.956,1.052Zm46.884-1.712-.184-.151c.3-.365.6-.742.878-1.12l.191.142C408.1,375.417,407.8,375.8,407.5,376.165Zm-48.762-.452c-.295-.373-.585-.757-.863-1.143l.193-.139c.276.383.564.765.856,1.135Zm50.48-1.845-.2-.134c.266-.391.526-.793.773-1.2l.2.125c-.249.406-.511.811-.779,1.205Zm-52.152-.48c-.259-.4-.513-.807-.755-1.216l.205-.121c.24.406.492.813.749,1.207Zm53.654-1.965-.208-.115c.229-.414.451-.838.66-1.262l.213.106c-.211.427-.435.855-.665,1.272Zm-55.107-.5c-.222-.42-.437-.85-.64-1.28l.215-.1c.2.426.415.853.635,1.27Zm56.378-2.073-.218-.1c.19-.433.372-.877.541-1.319l.222.085C412.361,367.966,412.177,368.413,411.986,368.85Zm-57.6-.514c-.182-.438-.357-.886-.519-1.332l.224-.081c.161.443.334.887.515,1.322Zm58.628-2.168-.226-.075c.149-.448.289-.905.417-1.36l.229.064c-.129.458-.27.919-.42,1.37Zm-59.605-.522c-.142-.454-.275-.917-.4-1.378l.23-.06c.12.457.252.917.393,1.367Zm60.381-2.237-.232-.054c.107-.459.2-.927.29-1.392l.234.043c-.086.469-.185.941-.292,1.4Zm-61.108-.535c-.1-.465-.189-.939-.267-1.408l.235-.039c.077.466.167.936.265,1.4Zm61.627-2.283-.236-.032c.064-.466.118-.942.161-1.413l.237.021c-.043.475-.1.954-.162,1.424Zm-62.1-.544c-.056-.471-.1-.951-.137-1.426l.237-.017c.034.472.08.948.136,1.416Zm62.355-2.31-.238-.011c.021-.472.032-.95.032-1.422h.238c0,.475-.011.957-.032,1.433ZM352,357.189c-.008-.292-.012-.59-.012-.885q0-.275,0-.549l.238,0q0,.272,0,.544c0,.293,0,.589.012.878Zm62.357-1.217c0-.472-.021-.95-.047-1.422l.238-.013c.026.475.042.957.047,1.433Zm-62.07-1.633-.238-.015c.03-.476.071-.956.122-1.428l.237.026C352.362,353.39,352.321,353.867,352.292,354.339Zm61.912-1.206c-.048-.469-.107-.944-.176-1.411l.236-.035c.069.471.129.949.177,1.422ZM352.6,351.512l-.235-.036c.073-.471.158-.946.252-1.411l.233.047C352.754,350.573,352.67,351.044,352.6,351.512Zm61.189-1.192c-.091-.464-.193-.932-.3-1.389l.231-.056c.112.461.215.932.307,1.4Zm-60.626-1.6-.231-.058c.116-.461.244-.926.381-1.382l.228.068C353.4,347.805,353.277,348.267,353.162,348.724Zm59.953-1.168c-.133-.453-.278-.909-.431-1.355l.225-.077c.155.45.3.909.435,1.366ZM353.981,346l-.225-.079c.158-.45.329-.9.508-1.344l.221.089C354.308,345.1,354.138,345.55,353.981,346Zm58.209-1.13c-.174-.438-.36-.878-.553-1.307l.217-.1c.195.432.382.875.557,1.317Zm-57.14-1.512-.216-.1c.2-.433.41-.867.629-1.291l.212.109C355.457,342.494,355.247,342.925,355.05,343.355Zm55.975-1.075c-.213-.42-.439-.841-.671-1.252l.207-.117c.234.413.461.838.676,1.261Zm-54.669-1.456-.206-.119c.237-.412.488-.825.744-1.227l.2.128C356.841,340,356.592,340.414,356.356,340.824Zm53.27-1.016c-.252-.4-.515-.8-.783-1.186l.2-.136c.27.389.535.791.789,1.195Zm-51.738-1.384-.195-.137c.274-.389.561-.777.853-1.153l.188.146C358.446,337.653,358.161,338.038,357.889,338.424Zm50.119-.951c-.287-.376-.586-.749-.888-1.11l.182-.153c.3.364.606.74.895,1.119Zm-48.374-1.3-.181-.154c.308-.362.629-.722.954-1.07l.174.162C360.257,335.459,359.938,335.817,359.633,336.176Zm46.548-.882c-.32-.348-.652-.693-.986-1.025l.168-.169c.337.335.671.682.993,1.033Zm-44.608-1.2-.166-.17c.34-.333.693-.662,1.047-.979l.159.178C362.261,333.439,361.911,333.765,361.574,334.1Zm42.59-.807c-.35-.318-.712-.631-1.075-.932l.152-.183c.366.3.73.619,1.084.939Zm-40.47-1.087-.15-.185c.368-.3.749-.6,1.131-.879l.142.191C364.438,331.611,364.06,331.9,363.694,332.2Zm38.277-.727c-.378-.285-.767-.564-1.156-.83l.134-.2c.392.268.784.55,1.165.837Zm-35.994-.965-.133-.2c.394-.265.8-.525,1.206-.772l.124.2C366.771,329.989,366.369,330.247,365.978,330.51Zm33.644-.642c-.4-.249-.815-.492-1.228-.721l.116-.208c.416.232.832.476,1.237.727Zm-31.218-.834-.114-.209c.417-.228.844-.449,1.271-.658l.1.214c-.423.207-.847.426-1.261.653Zm28.73-.552c-.424-.211-.858-.415-1.29-.606l.1-.218c.436.192.873.4,1.3.611Zm-26.18-.7-.095-.218c.436-.189.881-.37,1.325-.538l.085.223c-.44.167-.882.347-1.314.534Zm23.574-.456c-.441-.171-.892-.334-1.341-.485l.076-.226c.452.152.907.316,1.351.488Zm-20.918-.552-.074-.226c.452-.148.914-.288,1.372-.415l.064.229c-.454.126-.913.265-1.361.412Zm18.219-.354c-.454-.129-.917-.25-1.376-.358l.055-.232c.463.109.929.231,1.387.361Zm-15.479-.407-.053-.232c.464-.106.936-.2,1.4-.287l.042.234c-.464.084-.933.18-1.393.285Zm12.711-.246c-.464-.087-.936-.164-1.4-.23l.033-.236c.471.066.947.144,1.414.232Zm-9.912-.259-.031-.236c.471-.063.951-.116,1.424-.157l.021.237c-.47.041-.946.093-1.414.156Zm7.1-.137c-.469-.044-.946-.078-1.419-.1l.012-.238c.476.023.957.057,1.429.1Zm-4.263-.111-.01-.238c.438-.018.883-.028,1.325-.028h.108v.238H383.3c-.439,0-.881.009-1.316.027Z",
    transform: "translate(401.378 265.942)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M919.441,534.17a49.83,49.83,0,0,1,2.182,19.623,47.341,47.341,0,0,1-12.178-36.649A49.827,49.827,0,0,1,919.441,534.17Z",
    transform: "translate(-136.897 89.343)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1013.934,534.17a49.83,49.83,0,0,0-2.182,19.623,47.34,47.34,0,0,0,12.178-36.649A49.825,49.825,0,0,0,1013.934,534.17Z",
    transform: "translate(-227.026 89.343)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M981.95,518.866a49.829,49.829,0,0,1-3.708,19.392,47.341,47.341,0,0,1-.816-38.611A49.82,49.82,0,0,1,981.95,518.866Z",
    transform: "translate(-193.688 104.757)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 9.51,
    cy: 0.522,
    rx: 9.51,
    ry: 0.522,
    transform: "translate(775.042 642.614)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 1.044,
    cy: 1.044,
    rx: 1.044,
    ry: 1.044,
    transform: "translate(783.102 613.156)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(781.537 621.97)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(774.462 616.23)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(794.931 610.605)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(777.478 621.68)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(789.655 618.317)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(777.826 630.204)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(790.235 626.899)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 0.58,
    cy: 0.58,
    rx: 0.58,
    ry: 0.58,
    transform: "translate(784.61 627.479)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(752 615)",
    fill: "#00a050",
    fontSize: 38,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48-3",
    "data-name": "Ellipse 48",
    cx: 30.976,
    cy: 30.976,
    rx: 30.976,
    ry: 30.976,
    transform: "translate(801.933 613.883)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M385.937,392.888c-.358,0-.72-.006-1.075-.017l.008-.258c.51.016,1.03.02,1.542.013l0,.258Q386.177,392.888,385.937,392.888Zm2.032-.06-.015-.258c.511-.03,1.028-.072,1.537-.126l.027.257c-.513.054-1.034.1-1.549.127Zm-4.659-.04c-.515-.039-1.035-.091-1.547-.154l.032-.256c.507.062,1.024.114,1.535.153Zm7.749-.284-.039-.255c.507-.077,1.019-.166,1.519-.266l.05.253c-.5.1-1.019.19-1.531.268Zm-10.833-.094c-.509-.086-1.022-.185-1.526-.295l.055-.252c.5.109,1.01.207,1.514.292Zm13.881-.511-.062-.251c.5-.123,1-.259,1.488-.4l.073.248C395.113,391.637,394.608,391.775,394.107,391.9Zm-16.917-.148c-.5-.133-1-.279-1.492-.434l.078-.246c.488.154.986.3,1.481.431Zm19.9-.736-.085-.244c.483-.168.969-.35,1.445-.54l.1.24c-.479.192-.969.375-1.456.544Zm-22.863-.2c-.485-.178-.972-.37-1.449-.571l.1-.238c.473.2.957.39,1.438.567Zm25.745-.951-.107-.235c.464-.211.931-.436,1.386-.669l.117.23C400.905,389.422,400.435,389.649,399.968,389.862Zm-28.615-.257c-.466-.222-.933-.458-1.389-.7l.122-.228c.453.242.917.476,1.379.7Zm31.377-1.154-.128-.224c.445-.254.889-.521,1.32-.794l.138.218c-.434.275-.882.544-1.33.8Zm-34.122-.312c-.443-.264-.887-.542-1.319-.826l.142-.216c.429.282.869.558,1.309.82Zm36.745-1.347-.148-.211c.419-.293.837-.6,1.243-.911l.157.2C406.2,386.187,405.775,386.5,405.353,386.79Zm-39.342-.363c-.417-.3-.833-.62-1.237-.942l.161-.2c.4.32.814.635,1.228.935Zm41.8-1.529-.166-.2c.391-.33.779-.673,1.156-1.021l.175.19c-.379.35-.771.7-1.164,1.029Zm-44.234-.411c-.388-.34-.773-.693-1.146-1.051l.179-.186c.369.355.752.705,1.137,1.043Zm46.515-1.7-.184-.181c.36-.365.716-.742,1.058-1.122l.192.173c-.345.383-.7.763-1.067,1.131Zm-48.757-.453c-.356-.374-.708-.761-1.045-1.15l.2-.169c.335.386.684.77,1.037,1.141Zm50.838-1.856-.2-.164c.325-.4.646-.8.952-1.214l.207.155C412.827,379.668,412.5,380.08,412.176,380.479Zm-52.874-.49c-.32-.4-.634-.821-.936-1.24l.209-.151c.3.415.611.829.929,1.23Zm54.737-2-.214-.145c.288-.424.57-.86.838-1.3l.22.135c-.27.44-.555.88-.845,1.307Zm-56.55-.52c-.281-.431-.557-.875-.818-1.319l.222-.131c.26.441.533.881.812,1.309Zm58.178-2.131-.226-.125c.248-.448.489-.909.716-1.369l.231.114C416.159,374.422,415.916,374.886,415.667,375.338Zm-59.753-.543c-.241-.455-.474-.922-.694-1.387l.233-.11c.218.462.45.925.689,1.377Zm61.132-2.248-.236-.1c.206-.47.4-.951.587-1.43l.241.092C417.452,371.589,417.252,372.074,417.045,372.547Zm-62.455-.557c-.2-.475-.387-.961-.563-1.444l.243-.088c.174.48.362.962.559,1.433Zm63.571-2.351-.245-.081c.161-.485.313-.981.452-1.475l.249.07c-.14.5-.293,1-.455,1.486Zm-64.632-.566c-.154-.492-.3-.994-.429-1.494l.25-.066c.13.5.273.994.426,1.483ZM419,366.648l-.251-.059c.116-.5.221-1.006.314-1.51l.254.047c-.094.508-.2,1.02-.317,1.522Zm-66.261-.58c-.108-.5-.205-1.018-.29-1.527l.255-.042c.084.505.181,1.015.287,1.515Zm66.824-2.476-.256-.035c.069-.506.128-1.021.174-1.532l.257.023c-.047.515-.106,1.035-.176,1.544ZM352.233,363c-.061-.511-.111-1.031-.149-1.547l.257-.019c.037.512.087,1.028.147,1.535Zm67.613-2.505-.258-.012c.023-.511.035-1.03.035-1.542h.258c0,.515-.012,1.038-.035,1.553Zm-67.84-.594c-.009-.316-.013-.639-.013-.96q0-.3.005-.595l.258,0q-.005.295-.005.59c0,.318,0,.638.013.952Zm67.615-1.32c-.005-.512-.022-1.03-.051-1.542l.258-.014c.029.515.046,1.038.051,1.553Zm-67.3-1.771-.258-.016c.032-.516.077-1.037.132-1.548l.257.028C352.393,355.784,352.349,356.3,352.317,356.813Zm67.132-1.308c-.052-.509-.116-1.024-.191-1.53l.255-.038c.075.511.14,1.029.192,1.542Zm-66.8-1.758-.255-.039c.079-.511.171-1.025.273-1.53l.253.051C352.819,352.73,352.727,353.24,352.649,353.747ZM419,352.454c-.1-.5-.21-1.01-.33-1.507l.251-.061c.122.5.234,1.011.333,1.518Zm-65.738-1.73-.25-.063c.125-.5.264-1,.413-1.5l.247.074C353.523,349.728,353.385,350.229,353.26,350.725Zm65.008-1.267c-.144-.491-.3-.986-.467-1.47l.244-.084c.168.487.326.986.471,1.481Zm-64.12-1.691-.244-.086c.172-.488.357-.978.55-1.457l.239.1C354.5,346.8,354.319,347.283,354.149,347.767Zm63.117-1.225c-.188-.475-.39-.952-.6-1.417l.235-.106c.211.469.414.949.6,1.428ZM355.308,344.9l-.235-.108c.216-.469.445-.94.682-1.4l.229.118C355.749,343.969,355.521,344.437,355.308,344.9Zm60.7-1.166c-.231-.456-.476-.912-.728-1.357l.225-.127c.254.448.5.908.733,1.368Zm-59.279-1.578-.224-.129c.258-.447.529-.895.807-1.33l.218.139C357.249,341.27,356.98,341.714,356.724,342.158Zm57.762-1.1c-.273-.434-.558-.867-.849-1.286l.212-.147c.293.422.581.858.855,1.3Zm-56.1-1.5-.211-.149c.3-.422.609-.843.925-1.25l.2.158C358.99,338.72,358.681,339.137,358.386,339.556Zm54.345-1.032c-.311-.407-.635-.812-.963-1.2l.2-.166c.33.394.657.8.97,1.213Zm-52.454-1.407-.2-.167c.334-.392.682-.783,1.034-1.16l.189.176C360.954,336.341,360.609,336.729,360.277,337.118Zm50.474-.956c-.347-.377-.706-.752-1.069-1.112l.182-.183c.365.363.728.74,1.077,1.12Zm-48.369-1.3-.181-.185c.369-.361.751-.718,1.135-1.061l.172.193C363.127,334.15,362.748,334.5,362.381,334.863Zm46.182-.875c-.38-.345-.772-.685-1.166-1.01l.165-.2c.4.328.792.671,1.175,1.018Zm-43.882-1.179-.163-.2c.4-.325.812-.646,1.226-.953l.154.207C365.487,332.169,365.077,332.487,364.681,332.809Zm41.505-.788c-.41-.309-.832-.612-1.254-.9l.146-.213c.425.291.85.6,1.263.907Zm-39.029-1.047-.144-.214c.427-.287.867-.569,1.307-.837l.134.221C368.017,330.41,367.581,330.689,367.157,330.974Zm36.481-.7c-.436-.27-.884-.533-1.331-.782l.126-.226c.451.251.9.516,1.342.788Zm-33.85-.9-.124-.226c.452-.247.916-.487,1.378-.713l.113.232c-.459.224-.919.462-1.367.708Zm31.152-.6c-.459-.229-.93-.45-1.4-.657l.1-.236c.472.209.946.432,1.409.662Zm-28.388-.754-.1-.237c.472-.2.956-.4,1.436-.584l.092.241c-.477.181-.957.376-1.425.579Zm25.562-.495c-.478-.185-.967-.362-1.454-.526l.082-.245c.491.165.983.343,1.465.53Zm-22.682-.6-.08-.245c.491-.161.991-.312,1.488-.45l.069.249c-.493.137-.989.287-1.476.447Zm19.755-.384c-.492-.14-.994-.271-1.492-.388l.059-.251c.5.118,1.008.25,1.5.391ZM378.4,326.1l-.057-.252c.5-.115,1.015-.22,1.523-.311l.046.254c-.5.091-1.012.195-1.511.309Zm13.783-.267c-.5-.094-1.015-.178-1.522-.25l.036-.256c.511.072,1.027.156,1.534.251Zm-10.748-.281-.034-.256c.511-.068,1.031-.126,1.544-.17l.022.257c-.51.044-1.026.1-1.533.169Zm7.694-.148c-.508-.048-1.026-.085-1.538-.11l.013-.258c.516.025,1.038.062,1.55.111Zm-4.622-.12-.011-.258c.474-.02.958-.03,1.437-.03h.117v.258h-.116c-.476,0-.956.01-1.426.03Z",
    transform: "translate(443.209 291.56)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M614.53,624.049s-4.7-15.957.88-27.7a25.2,25.2,0,0,0,2.037-15.809,42.391,42.391,0,0,0-2.238-7.421",
    transform: "translate(211.823 56.044)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M616.7,545.477c0,1.956-3.54,7.625-3.54,7.625s-3.54-5.661-3.54-7.625a3.542,3.542,0,0,1,7.083,0Z",
    transform: "translate(213.806 76.256)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M633.268,572.743c-1.056,1.64-7.118,4.476-7.118,4.476s.109-6.685,1.172-8.325a3.54,3.54,0,1,1,5.943,3.849Z",
    transform: "translate(203.092 59.831)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M630.173,623.064c-1.759.88-8.4.271-8.4.271s3.469-5.714,5.215-6.594a3.545,3.545,0,1,1,3.188,6.334Z",
    transform: "translate(205.931 28.017)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M620.967,663.305c-1.573,1.161-8.237,1.689-8.237,1.689s2.463-6.217,4.025-7.389a3.544,3.544,0,1,1,4.222,5.693Z",
    transform: "translate(211.79 1.739)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M603.144,585.534c1.407,1.362,7.938,2.773,7.938,2.773s-1.6-6.506-3.012-7.854a3.54,3.54,0,0,0-4.926,5.081Z",
    transform: "translate(218.656 51.895)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M590.894,630.8c1.759.88,8.4.271,8.4.271s-3.469-5.714-5.215-6.594a3.545,3.545,0,0,0-3.188,6.334Z",
    transform: "translate(227.208 23.001)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M587.791,678.015c1.573,1.161,8.237,1.689,8.237,1.689s-2.463-6.217-4.025-7.389a3.544,3.544,0,0,0-4.222,5.693Z",
    transform: "translate(228.89 -7.796)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M616.7,545.477c0,1.956-3.54,7.625-3.54,7.625s-3.54-5.661-3.54-7.625a3.542,3.542,0,0,1,7.083,0Z",
    transform: "translate(213.806 76.256)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M633.268,572.743c-1.056,1.64-7.118,4.476-7.118,4.476s.109-6.685,1.172-8.325a3.54,3.54,0,1,1,5.943,3.849Z",
    transform: "translate(203.092 59.831)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M630.173,623.064c-1.759.88-8.4.271-8.4.271s3.469-5.714,5.215-6.594a3.545,3.545,0,1,1,3.188,6.334Z",
    transform: "translate(205.931 28.017)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M620.967,663.305c-1.573,1.161-8.237,1.689-8.237,1.689s2.463-6.217,4.025-7.389a3.544,3.544,0,1,1,4.222,5.693Z",
    transform: "translate(211.79 1.739)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M603.144,585.534c1.407,1.362,7.938,2.773,7.938,2.773s-1.6-6.506-3.012-7.854a3.54,3.54,0,0,0-4.926,5.081Z",
    transform: "translate(218.656 51.895)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M590.894,630.8c1.759.88,8.4.271,8.4.271s-3.469-5.714-5.215-6.594a3.545,3.545,0,0,0-3.188,6.334Z",
    transform: "translate(227.208 23.001)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M587.791,678.015c1.573,1.161,8.237,1.689,8.237,1.689s-2.463-6.217-4.025-7.389a3.544,3.544,0,0,0-4.222,5.693Z",
    transform: "translate(228.89 -7.796)",
    fill: "#00a050",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "+",
    transform: "translate(841 643)",
    fill: "#00a050",
    fontSize: 38,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpageStep2);
export default __webpack_public_path__ + "static/media/frontpage_step_2.4f5129493e5af0d02fe19aeab53ab3d3.svg";
export { ForwardRef as ReactComponent };